import React from 'react';

import {Route, Redirect, Switch} from "react-router-dom";
import _ from 'lodash';

import Header from 'components/Header';
import Login from 'pages/login';
import ForgotPassword from 'pages/forgot-password';
import OrganizationShow from "../pages/organizations/show";
import FacilityShow from 'pages/facilities/show';
import DevicesIndex from 'pages/configuration/devices-list';
// import DevicesList from 'pages/configuration/devices/DevicesList';
import DevicesEdit from "../pages/configuration/devices-edit";
import LocationsList from "../pages/configuration/locations/LocationsList";
import ViewLocationInfo from "../pages/configuration/locations/ViewLocationInfo";
import ResidentsList from "../pages/configuration/residents/List";
import NewResident from "../pages/configuration/residents/NewResident";
import EditResident from "../pages/configuration/residents/EditResident"
import UserList from "../pages/configuration/users/UserList";
import NewUser from "../pages/configuration/users/NewUser";
import EditUser from "../pages/configuration/users/EditUser";

const config = require(`config-${process.env.REACT_APP_ENV}.json`);

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}; // Empty state is updated by the parent auth context
    this.handleStateUpdate = this.handleStateUpdate.bind(this);
    this.handleSelectFacility = this.handleSelectFacility.bind(this);
  }

  handleStateUpdate(state) {
    this.setState(state);
  }

  handleSelectFacility(facility) {
    this.setState({selectedFacility: facility});
  }

  render() {
    const {auth} = this.props;
    return (
      <div className="container-fluid p-0">
        <Header
          auth={auth}
          organizationName={this.state.organizationName}
          facilityName={this.state.selectedFacility}
          sectionName={this.state.sectionName}/>

        <div className='main-content'>
          {this.state.flashMessage &&
            <div className='alert alert-info'>{this.state.flashMessage}</div>
          }

          {this.state.errorMessage && (
            <div className="alert alert-danger">{this.state.errorMessage}</div>
          )}
          {auth.currentUser && auth.initialized && (
            <React.Fragment>
              {/*<Button variant="contained">Hello</Button>*/}
              <Switch>
                <Route
                  path="/organizations/:org"
                  render={(props) => (
                    <OrganizationShow
                      auth={auth}
                      {...props}
                      onSelectFacility={this.handleSelectFacility}
                    />
                  )}
                />
                <Route
                  path="/facilities/:facility"
                  render={(props) => (
                    <FacilityShow auth={auth} {...props} />
                  )}
                />
                <Route
                  exact
                  path="/configuration/locations"
                  render={(props) => <LocationsList auth={auth} {...props} />}
                />
                <Route
                  exact
                  path="/configuration/users"
                  render={(props) => <UserList auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/users/:id/edit"
                  render={(props) => <EditUser auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/users/new-user"
                  render={(props) => <NewUser auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/locations/:location"
                  render={(props) => <ViewLocationInfo auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/residents/new-resident"
                  render={(props) => <NewResident auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/residents/:id/edit"
                  render={(props) => <EditResident auth={auth} {...props} />}
                />
                <Route
                  path="/configuration/residents"
                  render={(props) => <ResidentsList auth={auth} {...props} />}
                />
                {/*<Route*/}
                {/*  path="/configuration/devices"*/}
                {/*  render={(props) => <DevicesList auth={auth} {...props} />}*/}
                {/*/>*/}
                <Route
                  path="/configuration/devices"
                  render={(props) => (
                    <DevicesIndex auth={auth} {...props} />
                  )}
                />
                <Route
                  path="/configuration/devices-edit"
                  render={(props) => (
                    <DevicesEdit
                      auth={auth}
                      selectedDevices={props.location.state.selectedDevices}
                      {...props}
                    />
                  )}
                />
                {_.get(auth, "currentUser.defaultOrg") && (
                  <Redirect
                    from="/"
                    to={`/organizations/${auth.currentUser.defaultOrg}/show`}
                  />
                )}
                {_.get(auth, "currentUser.defaultFacility") && (
                  <Redirect
                    from="/"
                    to={`/facilities/${auth.currentUser.defaultFacility}/sections/${auth.currentUser.defaultSection}/rooms`}
                  />
                )}
                <Route
                  exact
                  path="/"
                  render={() => (
                    <p className="text-center">
                      The currently logged in user is not associated with a
                      facility. Please contact your system administrator for
                      support.
                    </p>
                  )}
                />
                <Redirect to="/"/>
              </Switch>
            </React.Fragment>
          )}

          {!auth.currentUser && auth.initialized &&
            <Switch>
              <Route path='/login' render={(props) => (
                <Login {...props} auth={auth}/>
              )}/>

              <Route path='/forgot-password' render={(props) => (
                <ForgotPassword {...props} auth={auth}/>
              )}/>

              <Redirect to={{pathname: '/login', state: {flashMessage: 'Please log in'}}}/>
            </Switch>
          }
        </div>
      </div>
    );
  }
}

export default Home;
